import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import { User } from './lib/User'

ReactDOM.createRoot(document.getElementById('root')).render(
  <User>
    <App />
  </User>
)
